import { defineMessages } from 'react-intl'

export default defineMessages({
    noSupplierSelected: {
        id: 'containers.AgenciesPage.components.AddAgency.noSupplierSelected',
        defaultMessage: 'Please select a supplier',
    },
    addNewAgency: {
        id: 'containers.AgenciesPage.components.AddAgency.addNewAgency',
        defaultMessage: 'Add new agency',
    },
    selectLabel: {
        id: 'containers.AgenciesPage.components.AddAgency.selectLabel',
        defaultMessage: 'Supplier',
    },
    selectDescription: {
        id: 'containers.AgenciesPage.components.AddAgency.selectDescription',
        defaultMessage: 'Please select the supplier you want to convert to an agency',
    },
    selectPlaceholder: {
        id: 'containers.AgenciesPage.components.AddAgency.selectPlaceholder',
        defaultMessage: 'Supplier',
    },
    submitAgency: {
        id: 'containers.AgenciesPage.components.AddAgency.submitAgency',
        defaultMessage: 'Convert to agency',
    },
})